import { addDataLayerEntry } from '@printdeal/data-layer-manager';

const Events = {
  Eec: 'gaEvent',
  QUOTE_REQUESTED: 'quote_requested',
  RE_REQUESTED_QUOTE: 're-request_quote',
  QUOTE_FIELD_INTERACTION: 'quote_form',
};
const Categories = {
  microConversions: 'micro_conversions',
  productDetailPage: 'product_detail_page',
};

const Actions = {
  quoteRequest: 'quote_requested',
  quoteCreateFromPdp: 'quote_create_request_from_pdp',
  reRequestQuote: 're-request_quote',
  quoteViewAll: 'quote_view_all',
  extendQuote: 'extend_quote',
  addCartQuotes: 'add_to_cart_quotes',
  uploadButtonClick: 'upload_button_click',
  completeQuoteForm: 'complete_quote_form',
};

export const dispatchDataLayerEventOnCreateQuoteRequest = (path: string) => {
  // GA4
  addDataLayerEntry(Events.QUOTE_REQUESTED, {
    action: Events.QUOTE_REQUESTED,
    path,
  });

  // GA3
  addDataLayerEntry(Events.Eec, {
    gaEvent: {
      eventCategory: Categories.productDetailPage,
      eventAction: Actions.quoteCreateFromPdp,
      eventLabel: path,
      eventValue: undefined,
      eventNonInteraction: false,
    },
  });
};

export const dispatchDataLayerEventOnQuoteRequest = () => {
  addDataLayerEntry(Events.Eec, {
    gaEvent: {
      eventCategory: Categories.microConversions,
      eventAction: Actions.quoteRequest,
      eventLabel: undefined,
      eventValue: undefined,
      eventNonInteraction: false,
    },
  });
};

export const dispatchDataLayerEventOnQuoteReRequest = () => {
  // GA4
  addDataLayerEntry(Events.RE_REQUESTED_QUOTE, {
    action: Events.RE_REQUESTED_QUOTE,
  });

  // GA3
  addDataLayerEntry(Events.Eec, {
    gaEvent: {
      eventCategory: Categories.microConversions,
      eventAction: Actions.reRequestQuote,
      eventLabel: undefined,
      eventValue: undefined,
      eventNonInteraction: false,
    },
  });
};

export const dispatchDataLayerEventOnQuoteViewAll = () => {
  addDataLayerEntry(Events.Eec, {
    gaEvent: {
      eventCategory: Categories.microConversions,
      eventAction: Actions.quoteViewAll,
      eventLabel: undefined,
      eventValue: undefined,
      eventNonInteraction: false,
    },
  });
};

export const dispatchDataLayerEventOnExtendQuote = () => {
  // GA4
  addDataLayerEntry(Events.Eec, {
    action: Actions.extendQuote,
  });

  // GA3
  addDataLayerEntry(Events.Eec, {
    gaEvent: {
      eventCategory: Categories.microConversions,
      eventAction: Actions.extendQuote,
      eventLabel: undefined,
      eventValue: undefined,
      eventNonInteraction: false,
    },
  });
};

export const dispatchDataLayerEventOnAddQuoteLineItemsToCart = () => {
  // GA4
  addDataLayerEntry(Events.Eec, {
    action: Actions.addCartQuotes,
  });

  // GA3
  addDataLayerEntry(Events.Eec, {
    gaEvent: {
      eventCategory: Categories.microConversions,
      eventAction: Actions.addCartQuotes,
      eventLabel: undefined,
      eventValue: undefined,
      eventNonInteraction: false,
    },
  });
};

export const dispatchDataLayerEventQuoteFieldInteraction = (
  fieldName: string,
  action: 'click' | 'fill' | 'empty',
) => {
  // GA4
  addDataLayerEntry(Events.QUOTE_FIELD_INTERACTION, {
    action: `form_field_interaction - ${action}`,
    field: fieldName,
  });
};

export const dispatchDataLayerEventQuoteUploadButton = () => {
  // GA4
  addDataLayerEntry(Events.QUOTE_FIELD_INTERACTION, {
    action: Actions.uploadButtonClick,
  });
};

export const dispatchDataLayerEventQuoteStepSubmit = () => {
  // GA4
  addDataLayerEntry(Events.QUOTE_FIELD_INTERACTION, {
    action: Actions.completeQuoteForm,
  });
};
